import { useEffect, useState, useCallback } from 'react';

import { SharedMenuElement } from 'modules/shared-menu/pages/SharedMenuEditorPage/types';

const useBulkSelection = (menuEditorList?: SharedMenuElement[]) => {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  const select = useCallback((id: string) => {
    setSelectedIds(oldState => new Set(oldState).add(id));
  }, []);

  const deselect = useCallback((id: string) => {
    setSelectedIds(oldState => {
      const updatedState = new Set(oldState);
      updatedState.delete(id);
      return updatedState;
    });
  }, []);

  const selectMultiple = useCallback((ids: string[]) => {
    setSelectedIds(oldState => new Set([...oldState, ...ids]));
  }, []);

  const deselectMultiple = useCallback((ids: string[]) => {
    setSelectedIds(oldState => {
      const updatedState = new Set(oldState);

      for (const id of ids) {
        updatedState.delete(id);
      }
      return updatedState;
    });
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedIds(new Set());
  }, []);

  // Remove item from bulk selection if it's moved away from the current list
  useEffect(() => {
    if (menuEditorList) {
      const missingItemIds = selectedIds
        ? [...selectedIds].filter(id => !menuEditorList.find(el => el.type === 'item' && el.itemState.id === id))
        : [];

      if (missingItemIds.length > 0) {
        deselectMultiple(missingItemIds);
      }
    }
  }, [deselectMultiple, menuEditorList, selectedIds]);

  return { selectedIds, select, deselect, selectMultiple, deselectMultiple, clearSelection };
};

export default useBulkSelection;
